


// import React, { useEffect, useState } from "react";
// import { Row, Col, Card, CardBody, Button, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
// import { useParams } from "react-router-dom";
// import axiosInstance from "../../Request";
// import { URL } from "../../api";
// import { toast } from "react-toastify";

// const LspProvidedJson = () => {
//   const { lid } = useParams();
//   const [loading, setLoading] = useState(false);
//   const [files, setFiles] = useState([]);
//   const [expandedKey, setExpandedKey] = useState(null);
  
//   // Modal states for PDF viewing
//   const [modal, setModal] = useState(false);
//   const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

//   useEffect(() => {
//     fetchFiles();
//     // Cleanup memory when component unmounts
//     return () => { if (selectedPdfUrl) window.URL.revokeObjectURL(selectedPdfUrl); };
//   }, [lid]);

//   const toggleModal = () => {
//     if (modal && selectedPdfUrl) window.URL.revokeObjectURL(selectedPdfUrl);
//     setModal(!modal);
//   };

//   const fetchFiles = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(`${URL.LSP_PROVIDED_JSON}?leadId=${lid}`);
//       if (response?.status === 200) setFiles(response.data?.files || []);
//     } catch (error) {
//       toast.error("Error while fetching files");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Logic to convert the Base64 string from Java back into a binary Blob
//   const base64ToBlob = (base64, type = "application/pdf") => {
//     const binStr = atob(base64);
//     const len = binStr.length;
//     const arr = new Uint8Array(len);
//     for (let i = 0; i < len; i++) arr[i] = binStr.charCodeAt(i);
//     return new Blob([arr], { type });
//   };

//   const handleView = (file) => {
//     if (file.fileType === "pdf") {
//       const blob = base64ToBlob(file.content);
//       const url = window.URL.createObjectURL(blob);
//       setSelectedPdfUrl(url);
//       setModal(true);
//     } else {
//       setExpandedKey(expandedKey === file.key ? null : file.key);
//     }
//   };

//   const handleDownload = (file) => {
//     const isPdf = file.fileType === "pdf";
//     const blob = isPdf ? base64ToBlob(file.content) : new Blob([file.content], { type: "text/plain" });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = file.key.split("/").pop();
//     link.click();
//     window.URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="pl-lg-4">
//       <h6 className="heading-small text-muted mb-4">LSP Provided Documents</h6>
//       {loading ? (
//         <div className="text-center"><Spinner color="primary" /></div>
//       ) : (
//         files.map((file, index) => (
//           <Card className="mb-3 shadow-sm" key={index}>
//             <CardBody>
//               <Row className="align-items-center">
//                 <Col md="8"><strong>{file.key}</strong></Col>
//                 <Col md="4" className="text-right">
//                   <Button size="sm" color="info" className="mr-2" onClick={() => handleView(file)}>
//                     {expandedKey === file.key ? "Hide" : "View"}
//                   </Button>
//                   <Button size="sm" color="primary" onClick={() => handleDownload(file)}>Download</Button>
//                 </Col>
//               </Row>
//               {expandedKey === file.key && file.fileType !== "pdf" && (
//                 <pre className="mt-3 p-3 bg-light border rounded" style={{ maxHeight: "300px", overflow: "auto" }}>
//                   {file.content}
//                 </pre>
//               )}
//             </CardBody>
//           </Card>
//         ))
//       )}

//       {/* Pop-up Modal for PDF View */}
//       <Modal isOpen={modal} toggle={toggleModal} size="lg">
//         <ModalHeader toggle={toggleModal}>Document Preview</ModalHeader>
//         <ModalBody style={{ height: "80vh", padding: "0" }}>
//           {selectedPdfUrl && (
//             <iframe src={selectedPdfUrl} width="100%" height="100%" title="PDF Viewer" style={{ border: "none" }} />
//           )}
//         </ModalBody>
//       </Modal>
//     </div>
//   );
// };

// export default LspProvidedJson;



import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Card, CardBody, Button, Spinner, Modal, ModalHeader, ModalBody, Container } from "reactstrap";
import { useParams, useLocation } from "react-router-dom";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import { toast } from "react-toastify";

const LspProvidedJson = () => {
  const { lid, cid } = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [expandedKey, setExpandedKey] = useState(null);
  const [modal, setModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const [viewingType, setViewingType] = useState("");

  const fetchFiles = useCallback(async () => {
    const queryParams = new URLSearchParams(location.search);
    const rawCid = cid || queryParams.get("customerId");
    const rawLid = lid || queryParams.get("leadId");

    const validLid = (rawLid && rawLid !== "undefined" && rawLid !== "null") ? rawLid : null;
    const validCid = (rawCid && rawCid !== "undefined" && rawCid !== "null") ? rawCid : null;

    if (!validLid && !validCid) return;

    try {
      setLoading(true);
      setFiles([]);
      let response = null;

      if (validLid) {
        response = await axiosInstance.get(`${URL.LSP_PROVIDED_JSON}?leadId=${validLid}`);
      }

      const isEmpty = !response || (response.status === 200 && (!response.data?.files || response.data.files.length === 0));
      if (isEmpty && validCid) {
        response = await axiosInstance.get(`${URL.LSP_PROVIDED_JSON_FILTER}?customerId=${validCid}`);
      }

      if (response?.status === 200) {
        setFiles(response.data?.files || []);
      }
    } catch (error) {
      toast.error("Error fetching documents");
    } finally {
      setLoading(false);
    }
  }, [lid, cid, location.search]);

  useEffect(() => {
    fetchFiles();
    return () => { if (selectedFileUrl) window.URL.revokeObjectURL(selectedFileUrl); };
  }, [fetchFiles]);

  const base64ToBlob = (base64, type) => {
    try {
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) arr[i] = binStr.charCodeAt(i);
      return new Blob([arr], { type });
    } catch (e) { return null; }
  };

  const handleDownload = (file) => {
    const type = file.fileType?.toLowerCase();
    let blob = ["pdf", "jpg", "jpeg", "png"].includes(type)
      ? base64ToBlob(file.content, type === "pdf" ? "application/pdf" : "image/jpeg")
      : new Blob([file.content], { type: "text/plain" });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.key.split("/").pop();
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const handleView = (file) => {
    const type = file.fileType?.toLowerCase();
    if (["pdf", "jpg", "jpeg", "png"].includes(type)) {
      const mime = type === "pdf" ? "application/pdf" : "image/jpeg";
      const blob = base64ToBlob(file.content, mime);
      const url = window.URL.createObjectURL(blob);
      setSelectedFileUrl(url);
      setViewingType(type);
      setModal(true);
    } else {
      setExpandedKey(expandedKey === file.key ? null : file.key);
    }
  };

  return (
    <>
      {/* 1. INCREASED HEADER GAP (mb-5) */}
      <div className="pt-5 mb-5">
        <Container fluid>
          <Row>
            <Col>
              <hr className="my-4" />
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid>
        <Row>
          <div className="col">
            <Card className="shadow-none border-0 bg-transparent">
              <CardBody className="px-0 py-0">
                {loading ? (
                  <div className="text-center py-5"><Spinner color="primary" /></div>
                ) : files.length > 0 ? (
                  files.map((file, index) => (
                    /* 2. INCREASED ROW LENGTH & PADDING (py-4) */
                    <div key={index} className="py-4 border-bottom bg-white px-4 mb-3 rounded shadow-sm">
                      <Row className="align-items-center">
                        <Col lg="8" md="7">
                          <h4 className="mb-0 text-dark font-weight-600" style={{ letterSpacing: '0.5px' }}>
                            {file.key}
                          </h4>
                          <span className="badge badge-pill badge-secondary mt-2">
                             {file.fileType.toUpperCase()}
                          </span>
                        </Col>
                        <Col lg="4" md="5" className="text-right">
                          <Button 
                            className="btn-round px-4" 
                            color="info" 
                            outline 
                            size="md" 
                            onClick={() => handleView(file)}
                          >
                            {expandedKey === file.key ? "Hide Content" : "View File"}
                          </Button>
                          <Button 
                            className="btn-round px-4 ml-3" 
                            color="primary" 
                            size="md" 
                            onClick={() => handleDownload(file)}
                          >
                            Download
                          </Button>
                        </Col>
                      </Row>

                      {/* Content expansion for Text types */}
                      {expandedKey === file.key && !["pdf", "jpg", "png", "jpeg"].includes(file.fileType) && (
                        <Row className="mt-4">
                          <Col>
                             <div className="bg-dark p-4 rounded shadow-inner" style={{ position: 'relative' }}>
                                <small className="text-light-50 mb-2 d-block">Raw File Content:</small>
                                <pre className="text-white m-0 text-xs" style={{ overflowX: 'auto', maxHeight: '500px', lineHeight: '1.6' }}>
                                  {file.content}
                                </pre>
                             </div>
                          </Col>
                        </Row>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5 bg-white rounded border">
                    <h4 className="text-muted">No documents found.</h4>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={() => setModal(!modal)} size="xl" centered scrollable>
        <ModalHeader toggle={() => setModal(!modal)} className="bg-white border-bottom">Document Preview</ModalHeader>
        <ModalBody style={{ height: "85vh", padding: "0" }} className="bg-secondary">
          {selectedFileUrl && (viewingType === "pdf" ?
            <iframe src={selectedFileUrl} width="100%" height="100%" title="PDF Preview" style={{ border: 'none' }} /> :
            <div className="text-center h-100 d-flex align-items-center justify-content-center p-4">
              <img src={selectedFileUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: '8px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }} />
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default LspProvidedJson;